import { IconChartBar, IconEdit, IconGripVertical } from "@tabler/icons-react";
import { Link } from "react-router-dom";
import { TableActions, TableAction, actionsColumn } from "../TableActions";
import { DataTable } from "../DataTable";
import { DataTableDraggableRow } from "mantine-datatable";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import { usePatchSurveyQuestionOrder } from "../../api/survey";
import { useParams } from "react-router-dom";
import DeleteSurveyQuestionModal from "./DeleteQuestions";

function QuestionsTable({ data, isLoading }) {
  const { id: surveyId } = useParams();
  const updateOrder = usePatchSurveyQuestionOrder(surveyId);

  const handleDragEnd = (result) => {
    if (!result.destination) return;

    const items = Array.from(data.data);
    const [moved] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, moved);

    const body = items.map((item, index) => ({
      id: item.id,
      order: index + 1,
    }));

    updateOrder.mutate(body);
  };

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId="datatable">
        {(provided) => (
          <div {...provided.droppableProps} ref={provided.innerRef}>
            <DataTable
              records={data?.data}
              columns={[
                { accessor: "", width: 40, hiddenContent: true },
                { accessor: "questionText", title: "Question Text" },
                { accessor: "questionType", title: "Question Type" },
                {
                  accessor: "answerOptions",
                  title: "Answer Options",
                  render: (q) =>
                    q.answerOptions
                      ? q.answerOptions.map((o) => o.label).join(", ")
                      : "-",
                },
                {
                  accessor: "totalResponses",
                  title: "Total Responses",
                  render: (q) => q.responseCount || 0,
                },
                actionsColumn(
                  (q) => {
                    const disableEdit = q.isLive || (q.responseCount || 0) > 0;

                    return (
                      <TableActions>
                        <TableAction
                          label={
                            disableEdit
                              ? "Cannot edit live question or question with responses"
                              : "Edit question"
                          }
                          icon={IconEdit}
                          disabled={disableEdit}
                          component={Link}
                          to={`./edit/${q.id}`}
                          onClick={(e) => disableEdit && e.preventDefault()}
                        />
                        <DeleteSurveyQuestionModal
                          surveyId={surveyId}
                          questionId={q.id}
                        />
                        <TableAction
                          label="Responses"
                          icon={IconChartBar}
                          component={Link}
                          to={`/app/surveys/${q.surveyId}/responses?questionId=${q.order}`}
                        />
                      </TableActions>
                    );
                  },
                  { title: "Actions", width: 160 }
                ),
              ]}
              fetching={isLoading}
              rowFactory={({ record, index, rowProps, children }) => (
                <Draggable
                  key={record.id}
                  draggableId={record.id.toString()}
                  index={index}
                >
                  {(provided, snapshot) => (
                    <DataTableDraggableRow
                      isDragging={snapshot.isDragging}
                      {...rowProps}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                    >
                      <td {...provided.dragHandleProps}>
                        <IconGripVertical size={16} />
                      </td>
                      {children}
                    </DataTableDraggableRow>
                  )}
                </Draggable>
              )}
            />
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  );
}

export default QuestionsTable;
